export const regex = {
  validProrithmMac: /([A-Za-z0-9]{2}:){5}[A-Za-z0-9]{2}/,
}
